import {
  SubscriptionGetDetailedResponse,
  SubscriptionGetLiteResponse,
  SubscriptionProvider,
} from "./types";

export const getSubscriptionProvider = (
  subscription?: SubscriptionGetLiteResponse | SubscriptionGetDetailedResponse
): SubscriptionProvider => subscription?.provider || "stripe";

// "x.myshopify.com" -> "x" (the store handle used in admin.shopify.com URLs)
export const getShopifyStoreHandle = (store?: string) =>
  store?.replace(".myshopify.com", "");
